<script setup lang="ts">
// This component is used to create a hidden div that indicates if the page is ready for printing or not
defineProps<{
  isLoading: boolean
  isError: boolean
  error: string | null
}>()
</script>
<template>
  <div id="page-scrapable" class="hidden"></div>
  <div v-if="!isLoading" id="page-ready" class="hidden"></div>
  <div v-if="isError" id="page-error" class="hidden">
    {{ error }}
  </div>
</template>
